import type { RouteObject } from "react-router-dom";
/** Deep poll pages have their own chrome; publishing composes the public messaging route factories. */
export const adminPollDetailRoutes: RouteObject[] = [
  {
    path: "admin/polls/create",
    lazy: async () =>
      (await import("@/features/polls/route")).loadPollCreateRoute(),
  },
  {
    path: "admin/polls/:pollId/questions",
    lazy: async () =>
      (await import("@/features/polls/route")).loadPollQuestionsRoute(),
  },
  {
    path: "admin/polls/:pollId",
    lazy: async () =>
      (await import("@/features/polls/route")).loadPollDetailRoute(),
  },
  {
    path: "admin/polls/:pollId/results",
    lazy: async () =>
      (await import("@/features/polls/route")).loadPollResultsRoute(),
  },
  {
    path: "admin/polls/:pollId/edit",
    lazy: async () =>
      (await import("@/features/polls/route")).loadPollEditRoute(),
  },
  {
    path: "admin/polls/:pollId/edit/review",
    lazy: async () =>
      (await import("@/features/polls/route")).loadPollDraftReviewRoute(),
  },
  {
    path: "admin/polls/:pollId/send",
    lazy: async () =>
      (
        await import("@/features/admin-messaging/route")
      ).loadPollMessageWorkflowRoute(),
    children: [
      {
        index: true,
        lazy: async () =>
          (
            await import("@/features/admin-messaging/route")
          ).loadPollMessageAudienceRoute(),
      },
      {
        path: "recipients",
        lazy: async () =>
          (
            await import("@/features/admin-messaging/route")
          ).loadMessageRecipientsRoute(),
      },
      {
        path: "compose",
        lazy: async () =>
          (
            await import("@/features/admin-messaging/route")
          ).loadMessageComposeRoute(),
      },
      {
        path: "preview",
        lazy: async () =>
          (
            await import("@/features/admin-messaging/route")
          ).loadMessagePreviewRoute(),
      },
      {
        path: "approval",
        lazy: async () =>
          (
            await import("@/features/admin-messaging/route")
          ).loadMessageApprovalRoute(),
      },
    ],
  },
];
